import React, { useState, useContext,useEffect  } from 'react';
import "../Styles.css";
import "./DocAppointment.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import DoctorAppointmentsList from "./doctorAppointmentsList";
import ConsultationRoom from "./ConsultationRoom";
import {LangCtx, FileCtx, SignalerCtx} from "../../../lib/context";
import UploadFileView from "../../common/fileUploads/components/uploadFileView";
import { appointmentList } from "../../../actions/appointment";

const DoctorAppointments = (props) => {
    const [current, setTab] = useState("PEA");
    const [selFile, setFileView] = useState(null);
    const {l} = useContext(LangCtx);
    const [wrCount,setWRCount]=useState(0);
    const { signaler } = useContext(SignalerCtx);

    useEffect(() => {
        const patientUserId = localStorage.getItem("meetingUserId");
        const meetingObj = JSON.parse(localStorage.getItem("meetingObj"));
        let patientObj = { ...meetingObj?.patientData};
        patientObj["apptId"] = meetingObj?.appointmentId;
        if (
            patientUserId &&
            patientUserId !== "" &&
            patientObj &&
            patientObj !== ""
        ) {
            signaler.declineCallRequest(patientUserId, patientObj);
            localStorage.removeItem('meetingUserId');
            localStorage.removeItem('meetingObj');
        }
    }, [signaler]);
    

    const loadData = () => {
        //setLoading(true);
        let _f = new Date();
        let _t = new Date();
        // _f.setHours(0, 0, 0, 0);
        _t.setHours(23, 59, 59, 99);
        _t.setMinutes(_t.getMinutes() + 30)
        appointmentList("doctor", ["confirmed"], _f.valueOf(), _t.valueOf(), "UA").then(res => {
            //setLoading(false);
            //res && res.status ? setData([...res.data]) : setData(null);
            res && res.status ? setWRCount(res.data.length): setWRCount(0)
        }).catch(err => {
            console.log("errrrrr ===== ", err);
            //setData(null);
            //setLoading(false);
        })
    }
    

    useEffect(() => {

        loadData()

        }, []);


    
    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.apptmnts}</h2>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        <div className={current === "PEA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("PEA")}>
                            <span>{l.pending}</span>
                        </div>
                        <div className={current === "CR" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CR")}>
                            <span>{l.waitingroom}</span>
                           {wrCount!==0 && <div className="waitingroomCounter"><small>{wrCount}</small></div> }
                        </div>
                        <div className={current === "UA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("UA")}>
                            <span>{l.upcoming}</span>
                        </div>
                        <div className={current === "PA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("PA")}>
                            <span>{l.past}</span>
                        </div>
                        <div className={current === "CA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CA")}>
                            <span>{l.cancelled_or_rejected}</span>
                        </div>
                        
                    </div>
                </div>
            </div>
            <FileCtx.Provider value={{ selFile, setFileView }}>
            {current === "PEA" || current === "UA" || current === "PA" || current === "CA" ? <DoctorAppointmentsList updateWrCount={loadData}   type={current}/>
            : <ConsultationRoom updateWrCount={loadData} />}
            </FileCtx.Provider>
            {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}
        </div>
    )
}

export default DoctorAppointments; 